var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg09(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164.8mm",
    height: "97.518mm",
    viewBox: "0 0 164.8 97.518",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7035"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7075"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7095"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m387 246h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m457.76 256.72 66-29.1-34.89-79.15-66 29.1z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m459 198.75h177.75v177.75h-177.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m196.5 230.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m515.69 218.61 61.7-37.11-37.11-61.7-61.7 37.11z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m604.13 228.28 27.39-60.23-60.23-27.39-27.39 60.23z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m401.25 110.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-611.57 -441.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 546.55 573.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.29 98.571h467.14v276.43h-467.14z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7035)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 21.7742 39.799198 48.811699 58.581249 69.0718 96.830299 114.09825 131.3662 140.37869 156.16859 170.40836 182.41299 199.68095 211.68559 221.45515 238.7231 247.7356 265.76059 281.55051 298.81845 313.0582 324.30579 336.31046 361.8699",
    y: 0
  }, "Edit movies or videos (A)"))), /*#__PURE__*/React.createElement("path", {
    d: "m277.88 268.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.88 268.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.38 196.12h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.38 196.12h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.13 196.12h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.13 196.12h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.38 279c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.38 279c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.63 279c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.63 279c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.28 277.08c0-1.07-0.87-1.94-1.95-1.94-1.07 0-1.95 0.87-1.95 1.94 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.22 277.28c0-1.07-0.88-1.95-1.95-1.95-1.08 0-1.95 0.88-1.95 1.95 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.38 313.12 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m300.38 313.12 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m278.49 256.72-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m278.49 256.72-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m363.58 274.62 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m363.58 274.62 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m345.38 247.88c0-5.39-7.22-9.76-16.13-9.76s-16.12 4.37-16.12 9.76h4.87c0-2.7 5.04-4.88 11.25-4.88s11.25 2.18 11.25 4.88z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.38 247.88c0-5.39-7.22-9.76-16.13-9.76s-16.12 4.37-16.12 9.76h4.87c0-2.7 5.04-4.88 11.25-4.88s11.25 2.18 11.25 4.88z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(387,246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.384 66.366h-36v-59.25h42v59.25zm4.5-1.5v-3.75h-4.5v3.75zm-33-17.231c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm-1.5 8.231h-4.5v3.75h4.5zm0-1.5v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm1.5 8.269c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm0 2.981v15.75c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-15.75c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25zm27 18.73c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm0-21.711v-0.039c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm1.5-8.269h4.5v-3.75h-4.5zm0 1.5v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm-1.5 9v-14.25c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25v14.25zm-28.5 0v-3.75h-4.5v3.75zm-4.5-56.25v3.75h4.5v-3.75zm6 0v14.25c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-14.25zm28.5 0v3.75h4.5v-3.75z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.91668 -.40407 .48458 1.0993 422.87 177.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7149)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.134 42.536v-30.17c0-1.657 1.3432-3 3-3h54c1.657 0 3 1.343 3 3v31.5h-50.69c-0.041-3e-3 -0.077 0.028-0.081 0.069-3e-3 0.041 0.028 0.078 0.07 0.081l49.951 7.943-1.531 9.629-59.256-9.424 1.5315-9.629zm58.5-0.17v-30c0-0.828-0.672-1.5-1.5-1.5h-54c-0.8285 0-1.5 0.672-1.5 1.5v30zm-2.025 17.505 1.06-6.666-8.127-1.292 5.606 7.725zm-3.554-0.565-5.607-7.725-8.974-1.425 5.605 7.725zm-11.071-1.761-5.606-7.725-8.975-1.425 5.606 7.725zm-11.07-1.76-5.606-7.725-8.974-1.429 5.606 7.725zm-20.048-3.188 8.976 1.425-5.608-7.725-8.975-1.425zm-2.094-0.333-5.607-7.723-1.7905-0.285-1.0605 6.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.884 34.866h-37.5v-10.5h37.5zm-1.5-9h-34.5v7.5h34.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4687,-1.88e-7,-7.54e-7,2.4687,459,198.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7171)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.134 52.11v-19.363l15 9.686zm1.5-2.753 10.735-6.925-10.735-6.931z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.384 27.366c-0.4142 0-0.75-0.336-0.75-0.75s0.3358-0.75 0.75-0.75h25.189l-13.344-13.345c-0.288-0.298-0.28-0.772 0.018-1.06 0.291-0.281 0.752-0.281 1.042 0l13.332 13.332c3e-3 3e-3 8e-3 3e-3 0.011 0 1e-3 -2e-3 2e-3 -4e-3 2e-3 -6e-3v-15.421c0-0.4142 0.336-0.75 0.75-0.75s0.75 0.3358 0.75 0.75v15.421c0 5e-3 3e-3 8e-3 8e-3 8e-3 2e-3 0 3e-3 -1e-3 5e-3 -2e-3l13.332-13.332c0.298-0.288 0.772-0.28 1.06 0.018 0.281 0.291 0.281 0.752 0 1.042l-13.345 13.345h25.19c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75h-3v30.75h3c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75h-26.25v3c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75v-3h-26.25c-0.4142 0-0.75-0.336-0.75-0.75s0.3358-0.75 0.75-0.75h3v-30.75zm4.5 30.75h45v-30.75h-45z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.5,230.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7193)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.884 36.366c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5-2.015 4.5-4.5 4.5c-2.484-2e-3 -4.498-2.016-4.5-4.5zm7.5 0c0-1.657-1.343-3-3-3s-3 1.343-3 3 1.343 3 3 3 3-1.343 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.134 9.366c-5.432 0.0019-10.636 2.185-14.444 6.059 11.492 10.648 12.177 28.597 1.528 40.088-10.648 11.492-28.596 12.177-40.088 1.528-11.492-10.648-12.176-28.596-1.528-40.088 10.251-11.064 27.368-12.171 38.959-2.52 4.094-4.197 9.709-6.5652 15.573-6.567zm-33.75 0c-14.912 0-27 12.088-27 27s12.088 27 27 27 27-12.088 27-27c-0.017-14.905-12.095-26.984-27-27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.384 44.616c3.728 0 6.75 3.022 6.75 6.75s-3.022 6.75-6.75 6.75-6.75-3.022-6.75-6.75c4e-3 -3.726 3.024-6.746 6.75-6.75zm0 1.5c-1.568-1e-3 -3.054 0.7-4.05 1.91 2.618 0.929 5.476 0.929 8.095 0-0.995-1.209-2.479-1.909-4.045-1.91zm-5.25 5.25c0 2.899 2.35 5.25 5.249 5.251 2.9 0 5.251-2.35 5.251-5.25 0-0.701-0.14-1.394-0.413-2.04-3.115 1.187-6.559 1.187-9.675 0-0.273 0.645-0.413 1.338-0.412 2.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.884 37.116c3.728 0 6.75 3.022 6.75 6.75s-3.022 6.75-6.75 6.75-6.75-3.022-6.75-6.75c4e-3 -3.726 3.024-6.746 6.75-6.75zm0 12c2.899 0 5.25-2.351 5.25-5.25 0-2.9-2.351-5.25-5.25-5.25-0.05 0-0.098 6e-3 -0.146 7e-3 -0.429 3.111-1.939 5.971-4.265 8.08 0.965 1.502 2.626 2.411 4.411 2.413zm-1.697-10.214c-2.631 0.887-4.108 3.679-3.36 6.354 1.749-1.72 2.923-3.94 3.36-6.354z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.884 35.616c-3.728 0-6.75-3.022-6.75-6.75s3.022-6.75 6.75-6.75 6.75 3.022 6.75 6.75c-4e-3 3.726-3.024 6.746-6.75 6.75zm-5.187-7.521c-0.384 2.437 1.001 4.807 3.312 5.669-0.551-2.163-1.698-4.127-3.312-5.669zm0.493-1.567c1.316 1.13 2.4 2.503 3.194 4.044v-0.956c3e-3 -2.014 0.286-4.018 0.841-5.954-1.738 0.222-3.252 1.298-4.035 2.866zm5.594-2.83c-0.592 1.917-0.896 3.912-0.9 5.918v4.5c2.899-0.015 5.238-2.377 5.223-5.277-0.013-2.532-1.831-4.694-4.323-5.141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.384 28.116c-3.728 0-6.75-3.022-6.75-6.75s3.022-6.75 6.75-6.75 6.75 3.022 6.75 6.75c-4e-3 3.726-3.024 6.746-6.75 6.75zm0-1.5c1.295 0 2.543-0.481 3.503-1.35-2.284-0.689-4.722-0.689-7.006 0 0.96 0.869 2.208 1.35 3.503 1.35zm0-10.5c-2.893-6e-3 -5.244 2.334-5.25 5.227-2e-3 0.946 0.252 1.875 0.735 2.688 2.918-1.053 6.112-1.053 9.03 0 1.478-2.488 0.66-5.702-1.828-7.18-0.813-0.483-1.741-0.737-2.687-0.735z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.884 35.616c-3.728 0-6.75-3.022-6.75-6.75s3.022-6.75 6.75-6.75 6.75 3.022 6.75 6.75c-4e-3 3.726-3.024 6.746-6.75 6.75zm0-12c-2.9 0-5.25 2.35-5.25 5.25 0 2.899 2.35 5.25 5.25 5.25 0.092 0 0.182-9e-3 0.274-0.014 0.582-2.949 2.139-5.617 4.42-7.575-0.886-1.781-2.704-2.909-4.694-2.911zm1.875 10.147c2.312-0.863 3.697-3.236 3.31-5.674-1.613 1.544-2.76 3.51-3.31 5.674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.884 37.116c3.728 0 6.75 3.022 6.75 6.75s-3.022 6.75-6.75 6.75-6.75-3.022-6.75-6.75c4e-3 -3.726 3.024-6.746 6.75-6.75zm5.056 8.144c0.751-2.675-0.726-5.47-3.359-6.357 0.435 2.416 1.609 4.637 3.359 6.357zm-5.056 3.856c1.785-2e-3 3.447-0.912 4.411-2.414-2.326-2.108-3.834-4.968-4.261-8.079-0.05 0-0.098-7e-3 -0.15-7e-3 -2.9 0-5.25 2.35-5.25 5.25 0 2.899 2.35 5.25 5.25 5.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7217)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-31.024 521.96 -783.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.384 66.366h-36v-59.25h42v59.25zm4.5-1.5v-3.75h-4.5v3.75zm-33-17.231c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm-1.5 8.231h-4.5v3.75h4.5zm0-1.5v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm1.5 8.269c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm0 2.981v15.75c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-15.75c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25zm27 18.73c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm0-21.711v-0.039c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm1.5-8.269h4.5v-3.75h-4.5zm0 1.5v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm-1.5 9v-14.25c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25v14.25zm-28.5 0v-3.75h-4.5v3.75zm-4.5-56.25v3.75h4.5v-3.75zm6 0v14.25c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-14.25zm28.5 0v3.75h4.5v-3.75z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83649 .38039 -.38039 .83649 571.29 140.66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.384 66.366h-36v-59.25h42v59.25zm4.5-1.5v-3.75h-4.5v3.75zm-33-17.231c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm-1.5 8.231h-4.5v3.75h4.5zm0-1.5v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm0-5.25v-3.75h-4.5v3.75zm1.5 8.269c8e-3 -6e-3 0.015-0.013 0.023-0.019-8e-3 -6e-3 -0.015-0.013-0.023-0.02zm0 2.981v15.75c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-15.75c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25zm27 18.73c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm0-21.711v-0.039c-8e-3 7e-3 -0.015 0.014-0.023 0.02 8e-3 6e-3 0.015 0.013 0.023 0.019zm1.5-8.269h4.5v-3.75h-4.5zm0 1.5v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm0 5.25v3.75h4.5v-3.75zm-1.5 9v-14.25c0-1.243-1.007-2.25-2.25-2.25h-22.5c-1.243 0-2.25 1.007-2.25 2.25v14.25zm-28.5 0v-3.75h-4.5v3.75zm-4.5-56.25v3.75h4.5v-3.75zm6 0v14.25c0 1.243 1.007 2.25 2.25 2.25h22.5c1.243 0 2.25-1.007 2.25-2.25v-14.25zm28.5 0v3.75h4.5v-3.75z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7257)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.25,110.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7267)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.073 33.366h-7.939v-1.5h7.5v-12h-7.5v-1.5h7.939l4.5-4.5h4.811v24l-4.811 0.012zm7.811 3v-21h-2.69l-4.06 4.06v12.879l4.06 4.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.134 35.616v-0.761h-2.692l-1.4998 1.5h-4.0582v-8.25h4.0612l1.4998 1.5h2.689v-13.489c0-1.657 1.343-3 3-3h30c1.657 0 3 1.343 3 3v19.5c-2e-3 1.608-1.274 2.928-2.882 2.988 4.984 2.966 6.619 9.409 3.654 14.393-2.966 4.983-9.41 6.619-14.393 3.653-4.983-2.965-6.619-9.409-3.653-14.393 0.89-1.496 2.139-2.747 3.633-3.641h-10.224c4.967 2.981 6.577 9.425 3.596 14.392-2.982 4.967-9.425 6.577-14.392 3.596-4.9676-2.982-6.5774-9.425-3.596-14.392 0.976-1.627 2.375-2.958 4.048-3.853-1.088-0.478-1.79-1.554-1.791-2.743zm0-4.512h-3.3128l-1.5-1.5h-1.9372v5.25h1.9402l1.5-1.5h3.3098zm18.75 16.512c0 4.971 4.029 9 9 9s9-4.029 9-9-4.029-9-9-9c-4.968 5e-3 -8.995 4.032-9 9zm-21 0c0 4.971 4.029 9 9 9s9-4.029 9-9-4.029-9-9-9c-4.968 5e-3 -8.995 4.032-9 9zm3.75-12c0 0.828 0.672 1.5 1.5 1.5h30c0.828 0 1.5-0.672 1.5-1.5v-19.5c0-0.828-0.672-1.5-1.5-1.5h-30c-0.828 0-1.5 0.672-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.631 19.116c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.381 50.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.381 47.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.381 47.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.381 44.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.381 50.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.381 47.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.381 44.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.381 47.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09);
export default __webpack_public_path__ + "static/media/09.5c77f7fbf868acc5580fc788d558d298.svg";
export { ForwardRef as ReactComponent };